/*
  Sticky checkout bar for the mobile cart page.

  Mirrors the product page's sticky add-to-cart bar (pujalane-sticky-atc.js):
  same delivery line, same cutoff countdown — both filled by
  pujalane-delivery-eta.js — with the estimated total and a single
  "Checkout Securely" button in place of the add/stepper controls.

  Two things need keeping in sync as the shopper edits quantities:
    - the total, which is copied straight out of the re-rendered cart footer so
      it always matches what Liquid formatted server-side;
    - the empty state, since an emptied cart has nothing to check out.

  Loaded with defer AFTER constants.js and pubsub.js, whose globals are bare
  consts in classic scripts — hence the `typeof` guards.
*/
(function () {
  var bar = document.querySelector('[data-pl-sticky-cart]');
  if (!bar) return;

  var totalEl = bar.querySelector('[data-pl-cart-total]');
  var goBtn = bar.querySelector('[data-pl-checkout]');
  var footer = document.getElementById('main-cart-footer');

  /* ---------- checkout ---------- */

  // The button is a real submit for #cart (name="checkout"), so it works with
  // no JS at all. When the theme's own checkout button is on the page we click
  // that instead: apps bind to it — terms-of-sale gates, upsells — and a bare
  // form submit would step straight past them.
  if (goBtn) {
    goBtn.addEventListener('click', function (event) {
      var real = document.querySelector('#checkout:not([disabled])');
      if (!real || real === goBtn) return; // fall through to the native submit

      event.preventDefault();
      real.click();
    });
  }

  /* ---------- total ---------- */

  // cart.js replaces the innerHTML of #main-cart-footer .js-contents on every
  // quantity change, so the freshly rendered total is already in the DOM —
  // copying it avoids re-implementing Shopify's money formatting here.
  // Every write below is guarded by an equality check. Assigning textContent
  // replaces the text node even when the string is identical, so an unguarded
  // write inside an observed subtree re-triggers the observer and spins the
  // main thread forever — which locks up the whole page.
  function syncTotal() {
    if (!totalEl || !footer) return;

    var rendered = footer.querySelector('.totals__total-value');
    if (rendered) {
      var next = rendered.textContent.trim();
      if (totalEl.textContent !== next) totalEl.textContent = next;
    }

    // Dawn toggles is-empty on the footer itself; an empty cart cannot be
    // checked out.
    var empty = footer.classList.contains('is-empty');
    if (bar.hidden !== empty) bar.hidden = empty;
    if (goBtn && goBtn.disabled !== empty) goBtn.disabled = empty;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncTotal);
  }

  // Belt and braces: the cart page can also be repainted by apps that re-render
  // the section without publishing anything.
  //
  // Scoped to .js-contents, NOT the whole footer. That is the node cart.js
  // refills, and it excludes this bar — which sits outside it — so the
  // observer can never see its own writes. Watching the footer instead put
  // the bar inside the observed subtree and fed it back into itself.
  var rerendered = footer && footer.querySelector('.js-contents');
  if (rerendered && typeof MutationObserver === 'function') {
    new MutationObserver(syncTotal).observe(rerendered, { childList: true, subtree: true });
  }

  /* ---------- layout ---------- */

  // The bottom nav is an app block of unknown height, so the bar is lifted
  // clear of it by measuring rather than by a hard-coded offset. The same
  // value pads the page so the bar never covers the end of the content.
  function measure() {
    var nav = document.querySelector('[data-nav-item]');
    var navBox = nav ? nav.closest('div') : null;
    var navHeight = navBox ? navBox.getBoundingClientRect().height : 0;

    document.documentElement.style.setProperty('--pl-stickycart-navgap', navHeight + 'px');
    document.documentElement.style.setProperty(
      '--pl-stickycart-height',
      bar.getBoundingClientRect().height + 'px'
    );
  }

  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);

  syncTotal();
})();
